<template>
  <v-layout row wrap>
    <v-flex d-flex>
      <v-card color="light-blue darken-1" dark="dark" hover="hover" to="/invoice/manualCharge">
        <v-card-text style="height: 128px;">
          <v-layout
            align-center
            justify-center
            column
            fill-height
          >
            <v-progress-circular
              v-if="isLoading"
              size="70"
              width="7"
              color="white"
              indeterminate="indeterminate"
            ></v-progress-circular>
            <animated-number
              class="display-1 font-weight-light"
              v-if="!isLoading"
              :value="manualCharge"
              :formatValue="formatToNumber"
              :duration="1000"
            ></animated-number>
            <div class="text-xs-center body-1">{{ $t("labels.manualCharge") }}</div>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex d-flex>
      <v-card color="teal accent-3" dark="dark" hover="hover" to="/invoice/readytobemade">
        <v-card-text style="height: 128px;">
          <v-layout
            align-center
            justify-center
            column
            fill-height
          >
            <v-progress-circular
              v-if="isLoading"
              size="70"
              width="7"
              color="white"
              indeterminate="indeterminate"
            ></v-progress-circular>
            <animated-number
              class="display-1 font-weight-light"
              v-if="!isLoading"
              :value="readyInvoice"
              :formatValue="formatToNumber"
              :duration="1000"
            ></animated-number>
            <div class="text-xs-center body-1">{{ $t("labels.readyInvoice") }}</div>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import dashbaordService from "../../service.js";
import AnimatedNumber from "animated-number-vue";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      manualCharge: 0,
      readyInvoice: 0,
      isLoading: true
    };
  },
  components: {
    AnimatedNumber
  },
  computed: {
    ...mapGetters("global", ["currentUser"])
  },
  mounted() {
    this.getInvoicesCount();
  },
  methods: {
    formatToNumber(value) {
      return `${value.toFixed(0)}`;
    },
    getInvoicesCount() {
      dashbaordService
        .getInvoicesCount()
        .then(result => {
          this.manualCharge = result.data.manualChargeInvoice;
          this.readyInvoice = result.data.invoicesReadyToBeMade;
          this.isLoading = false;
        })
        .catch(err => {
          console.log("manual invoice", err);
        });
    }
  }
};
</script>

<style scoped></style>
